import { render, staticRenderFns } from "./V2Hand.vue?vue&type=template&id=448a56fe&scoped=true&"
import script from "./V2Hand.vue?vue&type=script&lang=js&"
export * from "./V2Hand.vue?vue&type=script&lang=js&"
import style0 from "./V2Hand.vue?vue&type=style&index=0&id=448a56fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a56fe",
  null
  
)

export default component.exports